module.exports = __webpack_public_path__ + "img/Indomaret-logo.476407a5.svg";